import React, { Component } from 'react';
import '../../css/modal.scss';
import { NaverMap, Marker, Polyline } from 'react-naver-maps';
import { comma, formatKm } from '../../lib/util/numberUtil';
import image from '../../res/image';

class MapModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isOpen, close } = this.props;
    const navermaps = window.naver.maps;
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <div className="Modal-detail-overlay" onClick={close} />
            <div className="Modal-detail">
              <div className="map-title-container">
                <div className="map-title-text">
                  고객
                  <br />
                  주소
                </div>
                <div className="map-title-address">
                  <div>
                    {this.props.destAddr1} {this.props.destAddr2}
                  </div>
                  <div>
                    {this.props.destAddr3} {this.props.destAddr2}
                  </div>
                </div>
                <div className="map-title-close" onClick={this.props.close}>
                  <img
                    style={{ display: 'inline' }}
                    src={image.closeIcon}
                    alt=""
                  />
                </div>
                <div className="map-title-price">
                  배달비용:{' '}
                  {comma(
                    this.props.deliveryBasicPrice + this.props.deliveryAddPrice
                  )}
                  원
                </div>
                <div className="map-title-distance">
                  배달거리: {formatKm(this.props.dist)}
                </div>
              </div>

              <NaverMap
                className="map-navermap"
                defaultZoom={14}
                center={{
                  lat: this.props.targetLat,
                  lng: this.props.targetLng,
                }}>
                <Marker
                  position={
                    new navermaps.LatLng(
                      this.props.targetLat,
                      this.props.targetLng
                    )
                  }
                  icon={image.MarkerRiderIcon}
                />
                <Marker
                  position={
                    new navermaps.LatLng(this.props.frLat, this.props.frLng)
                  }
                  icon={image.MarkerTargetIcon}
                />
                <Polyline
                  path={[
                    new navermaps.LatLng(this.props.frLat, this.props.frLng),
                    new navermaps.LatLng(
                      this.props.targetLat,
                      this.props.targetLng
                    ),
                  ]}
                  // clickable // 사용자 인터랙션을 받기 위해 clickable을 true로 설정합니다.
                  strokeColor={'#5347AA'}
                  strokeWeight={5}
                />
              </NaverMap>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

export default MapModal;
